// extracted by mini-css-extract-plugin
module.exports = {"text":"subtle-info_text__jmBAu","light":"subtle-info_light__brUPa","dark":"subtle-info_dark__8BiQY"};